import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=0baef826&scoped=true&"
import script from "./privacy.vue?vue&type=script&lang=ts&"
export * from "./privacy.vue?vue&type=script&lang=ts&"
import style0 from "./privacy.vue?vue&type=style&index=0&id=0baef826&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baef826",
  null
  
)

export default component.exports